export default {
  empty: 'Nie znaleziono instancji części.',
  addPart: 'Dodaj część',
  editPart: 'Edytuj część',
  createOrder: 'Utwórz zamówienie',
  selectOrder: 'Wybierz zamówienie (opcjonalnie)',
  selectRevision: 'Wybierz rewizję części',
  confirmDelete: 'Usunąć część "{part}" z tego wsadu?',
};
